import { Outlet } from 'react-router-dom'
import TabelaGrupoSede from './components/tabela'

export default function Cargo() {

  return (
    <>
      <Outlet />
      <TabelaGrupoSede />
    </>
  )
}
